import { ALLOWED_REDIRECT_ORIGINS } from "./allowedOrigins";

// Returns the redirect target only if its origin is allowlisted, else null.
export function getSafeRedirectUrl(
  redirectUrl: string | null | undefined
): string | null {
  if (!redirectUrl) {
    return null;
  }

  let url: URL;
  try {
    url = new URL(redirectUrl);
  } catch {
    return null;
  }

  const isLocalhost =
    url.hostname === "localhost" || url.hostname === "127.0.0.1";
  const hasSafeProtocol =
    url.protocol === "https:" || (url.protocol === "http:" && isLocalhost);
  if (!hasSafeProtocol) {
    return null;
  }

  if (!ALLOWED_REDIRECT_ORIGINS.has(url.origin)) {
    return null;
  }

  // Return the normalised URL so the browser sees exactly what we validated.
  return url.href;
}
